import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { StaffImportViewService } from 'app/modules/staff-count/services/staff-import-view.service';
import { StaffImportService } from 'app/modules/staff-count/services/staff-import.service';
import Utils from 'app/Utils';

@Component({
    selector: 'app-importar-empresa-modal',
    templateUrl: './importar-empresa-modal.component.html',
    styleUrls: ['./importar-empresa-modal.component.scss'],
    standalone: false
})
export class ImportarEmpresaModalComponent implements OnInit {

  displayedColumns: string[] = ['name', 'name1', 'name2', 'name3'];
  dataSource: { id: any, parent: any; name: string, name1: string, name2: string, name3: string, style: string, mainCompanyId: number, invalid: boolean }[] = [];

  private currentCompanyId = 0;
  private currentUser: any;
  private companyData: any[];
  companyName: string;
  sublevel = 1;
  previoudParentId: number;
  isloading= false;

  constructor(public dialogRef: MatDialogRef<ImportarEmpresaModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public sharedService: SharedService, 
    public staffImportService: StaffImportService, 
    public staffImportViewService: StaffImportViewService, 
    public dialog: MatDialog) {
     }

  ngOnInit(): void {
    this.currentCompanyId = this.data.empresaId;
    this.companyName =  this.data.empresa;
    // this.currentCompanyId = Number(localStorage.getItem('Empresa'));
    // this.companyName =  localStorage.getItem('SelectedCompanyName');
    this.currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
    if (this.currentUser) {
        this.getCompanyList();
    }

  }
  getCompanyList(): void {
    this.isloading = true;
    this.staffImportService.getEmpressaTreeViewById(this.currentCompanyId).subscribe((res: any) => {
        if (res.code === 0) {     
            this.companyData = res.result;
            this.data = [];            
            this.dataSource = [];
            var mainCompany = this.companyData.find(t => t.id == this.currentCompanyId);   // one 
            if(mainCompany){
              var subCompany =  this.companyData.filter(t => t.parent == mainCompany.id);   // list
              if(subCompany.length>0){
                this.populateDataSource(subCompany);  
                this.dataSource  = this.data;
                this.isloading = false;
              }else{
                this.sharedService.ShowSnackBar('Esta empresa no contiene otras empresas o delegaciones', 'Okay', 4000);
                this.isloading = false;
              }
            }
        } else if (res.code === 1) {
          this.data = [];
          this.dataSource = [];
          this.isloading = false;
        }
    });
}

  populateDataSource(objects: any){   
    for(var z=0 ; z < objects.length; ++z ){ 
      var styleText = '';
      if(this.sublevel == 1)
        styleText = "parent-rec";
      if(this.sublevel == 2)
        styleText = "sub-lvl-one";
      if(this.sublevel == 3)
        styleText = "sub-lvl-two";
      if(this.sublevel == 4)
        styleText = "sub-lvl-three"; 
      var item = objects[z].importarEmpresa;
      this.data.push({
        id: objects[z].id, 
        parent: objects[z].parent, 
        name: objects[z].text, 
        name1: item?item.parte1: null, 
        name2: item?item.parte2: null, 
        name3: item?item.parte3: null, 
        style: styleText, 
        mainCompanyId: this.currentCompanyId});                  
      var subCompany = this.companyData.filter(t => t.parent == objects[z].id); 
      this.previoudParentId = objects[z].parent;
      if(subCompany && subCompany.length !=0){
        this.sublevel = this.sublevel + 1;    
        this.populateDataSource(subCompany);    
      }else{
        if(this.previoudParentId && objects[z].parent == this.previoudParentId){
          if(this.data.filter(t=>t.parent === this.previoudParentId).length == this.companyData.filter(j=>j.parent === this.previoudParentId).length) {
            this.sublevel = 1;            
          }
        }else {        
        this.sublevel = 1;
        }
      }
    }
  }

  saveEspecificarEmpresas(){
    if(this.dataSource.length != 0){ this.dataSource.forEach(x=>x.invalid = false); }
    for(var x=0; x< this.dataSource.length;++x){
      const name1 = this.dataSource[x].name1? this.dataSource[x].name1.trim(): this.dataSource[x].name1;   
      const name2 = this.dataSource[x].name2? this.dataSource[x].name2.trim(): this.dataSource[x].name2;   
      const name3= this.dataSource[x].name3? this.dataSource[x].name3.trim(): this.dataSource[x].name3;   
      if(!name1 || name1 ==""){
        if(name2 && !name3){this.dataSource[x].invalid = true;}
        if(!name2 && name3){this.dataSource[x].invalid = true;}
        if(name2 && name3){this.dataSource[x].invalid = true;}
      }
    }
    if(this.dataSource.filter(t=>t.invalid).length !=0){
      this.sharedService.ShowSnackBar('Identificador principal should not be empty', 'Okay', 4000);
      return;
    }
    this.staffImportService.SaveImportarEmpresa(this.dataSource)
    .subscribe(res => {   
      if (res.code === 0) {
        this.sharedService.ShowSnackBar('¡Guardado correctamente!', 'Okay', 4000);
        this.getCompanyList();
      } else {
        this.sharedService.ShowSnackBar('¡Se ha producido un error al guardar!');
      }
    }, err => {
      this.sharedService.ShowSnackBar('¡Se ha producido un error al guardar!');
      console.error(err);
    });
  }

  cancel(){
    this.dialogRef.close();
  }
}

